function initScrollSmoother() {
    // Don't initialize smooth scroll in WordPress admin area
    if (window.location.href.indexOf('/wp-admin/') !== -1) {
        return null;
    }
    
    // Check if already initialized
    if (window.scrollSmoother) {
        return window.scrollSmoother;
    }
    
    // Only initialize on non-touch devices using GSAP's built-in detection
    if (!ScrollTrigger.isTouch) {
        window.scrollSmoother = ScrollSmoother.create({
            wrapper: "#page-wrapper",
            content: "#page",
            smooth: 1.5,              // Slightly higher for better feel
            effects: true,
            normalizeScroll: true,    // Usually better as true
            ignoreMobileResize: true,
            onUpdate: (self) => {
                // Custom scroll position tracking if needed
            }
        });
    }
    
    return window.scrollSmoother;
}

// More robust initialization
function waitForGSAP() {
    return new Promise((resolve) => {
        if (typeof gsap !== 'undefined' && typeof ScrollSmoother !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
            resolve();
        } else {
            const checkGSAP = setInterval(() => {
                if (typeof gsap !== 'undefined' && typeof ScrollSmoother !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
                    clearInterval(checkGSAP);
                    resolve();
                }
            }, 100);
        }
    });
}

// Initialize
waitForGSAP().then(() => {
    initScrollSmoother();
});

